module.exports = __webpack_public_path__ + "static/media/Prompt-Regular.b338ce06.ttf";